import apiClient from "../../services/apiClient";
import { DynamoDBItem, PassageData } from "../types";
import { mobileAppUri, dataLoaderUri } from "../API";

export const fetchPassages = async (
  section: string
): Promise<PassageData[]> => {
  try {
    const response = await apiClient.get(
      `${mobileAppUri}/api/v1/passages`,
      { params: { section } }
    );

    console.log(
      `API response for passages (section: ${section}):`,
      response
    ); // Log the raw response

    // *** FIX IS HERE ***
    // Check if the response data has an 'items' property and if it's an array
    if (response && Array.isArray(response.items)) {
      // Map over response.items instead of response
      return response.items.map((item: any): PassageData => {
        // Ensure item exists and handle potential DynamoDB structure ({ S: 'value' })
        // This helper assumes your data might come back like item.Identifier.S
        // Adjust if your API returns plain strings directly
        const getString = (field: any): string =>
          field && typeof field.S === "string"
            ? field.S
            : typeof field === "string"
            ? field
            : "";

        return {
          Identifier: getString(item.Identifier),
          Level: getString(item.Level), // This should match the requested 'section'
          Genre: getString(item.Genre),
          
          Targ_Lang_Code: getString(item.Targ_Lang_Code),
          Targ_Lang_Title: getString(item.Targ_Lang_Title),
          Targ_Lang_Description: getString(item.Targ_Lang_Description),
          Targ_Lang_Passage: getString(item.Targ_Lang_Passage),
          Targ_Passage_Word_Timings: getString(item.Targ_Passage_Word_Timings),
          Targ_Passage_Audio_URL: getString(item.Targ_Passage_Audio_URL),
          Targ_Lang_Question_1: getString(item.Targ_Lang_Question_1),
          Targ_Lang_Answer_1: getString(item.Targ_Lang_Answer_1),
          Targ_Lang_Options_1: getString(item.Targ_Lang_Options_1), // Keep as string if stored like that
          Targ_Lang_Question_2: getString(item.Targ_Lang_Question_2),
          Targ_Lang_Answer_2: getString(item.Targ_Lang_Answer_2),
          Targ_Lang_Options_2: getString(item.Targ_Lang_Options_2),
          Targ_Lang_Question_3: getString(item.Targ_Lang_Question_3),
          Targ_Lang_Answer_3: getString(item.Targ_Lang_Answer_3),
          Targ_Lang_Options_3: getString(item.Targ_Lang_Options_3),
          Targ_Lang_Question_4: getString(item.Targ_Lang_Question_4),
          Targ_Lang_Answer_4: getString(item.Targ_Lang_Answer_4),
          Targ_Lang_Options_4: getString(item.Targ_Lang_Options_4),
          ImageURL: getString(item.ImageURL),
          Prompt: getString(item.Prompt),
          Section: getString(item.Section), // This might also just be 'Level'
          SelectedWordIds: getString(item.SelectedWordIds),
        };
      });
    } else {
      // Handle cases where response is not as expected (e.g., empty response, or no 'items' array)
      console.warn(
        `WorkspacePassages received unexpected data structure for section "${section}":`,
        response
      );
      return []; // Return an empty array if the structure is wrong
    }
  } catch (error) {
    console.error(`Error in fetchPassages for section "${section}":`, error);
    // Re-throw the error so the calling component (Passages.tsx) can handle it (e.g., show 404 message)
    throw error;
  }
};

export const addPassage = async (data: PassageData): Promise<any> => {
  try {
    const response = await apiClient.post(
      `${dataLoaderUri}/api/v1/add-passage`,
      data
    );
    return response;
  } catch (error: any) {
    console.error("Error adding passage:", error);
    throw error;
  }
};

export const updatePassage = async (
  identifier: string,
  level: string,
  data: PassageData // Use the specific type here
): Promise<any> => {
  // *** FIX: Correct template literal for URL construction ***
  const url = `${dataLoaderUri}/api/v1/update-passage/${identifier}/${level}`;
  // *** END FIX ***

  console.log(`Attempting PUT to: ${url}`); // Log the correctly constructed URL
  console.log("Sending update payload:", JSON.stringify(data, null, 2));

  try {
    const response = await apiClient.put(url, data);
    console.log("Update successful:", response);
    return response;
  } catch (error) {
    console.error("Error during updatePassage:", error);
    throw error; // Re-throw
  }
};

export const deletePassage = async (
  identifier: string,
  level: string
): Promise<any> => {
  return apiClient.request({
    method: 'delete',
    url: `${dataLoaderUri}/api/v1/delete-passage/${identifier}/${level}`,
    data: { Identifier: identifier, Level: level }
  });
};

// const API_BASE_URL =
//   "http://languagebackend.us-east-2.elasticbeanstalk.com/api";

// export const fetchSections = async (level: string): Promise<string[]> => {
//   const response = await axios.get(`${API_BASE_URL}/sections?Level=${level}`);
//   return response.data.map(
//     (item: { Identifier: { S: string } }) => item.Identifier.S
//   );
// };

// export const fetchData = async (section: string): Promise<PassageData[]> => {
//   const response = await axios.get(`${API_BASE_URL}/passages?Level=${section}`);
//   return response.data.map((item: any) => ({
//     Identifier: item.Identifier?.S || "",
//     Level: item.Level?.S || "",
//     Genre: item.Genre?.S || "",
//     Base_Lang_Code: item.Base_Lang_Code?.S || "",
//     Base_Lang_Title: item.Base_Lang_Title?.S || "",
//     Base_Lang_Description: item.Base_Lang_Description?.S || "",
//     Base_Lang_Passage: item.Base_Lang_Passage?.S || "",
//     Base_Lang_Question_1: item.Base_Lang_Question_1?.S || "",
//     Base_Lang_Answer_1: item.Base_Lang_Answer_1?.S || "",
//     Base_Lang_Options_1: item.Base_Lang_Options_1?.S || "[]", // JSON string
//     Base_Lang_Question_2: item.Base_Lang_Question_2?.S || "",
//     Base_Lang_Answer_2: item.Base_Lang_Answer_2?.S || "",
//     Base_Lang_Options_2: item.Base_Lang_Options_2?.S || "[]", // JSON string
//     Base_Lang_Question_3: item.Base_Lang_Question_3?.S || "",
//     Base_Lang_Answer_3: item.Base_Lang_Answer_3?.S || "",
//     Base_Lang_Options_3: item.Base_Lang_Options_3?.S || "[]", // JSON string
//     Base_Lang_Question_4: item.Base_Lang_Question_4?.S || "",
//     Base_Lang_Answer_4: item.Base_Lang_Answer_4?.S || "",
//     Base_Lang_Options_4: item.Base_Lang_Options_4?.S || "[]", // JSON string
//     Targ_Lang_Code: item.Targ_Lang_Code?.S || "",
//     Targ_Lang_Title: item.Targ_Lang_Title?.S || "",
//     Targ_Lang_Description: item.Targ_Lang_Description?.S || "",
//     Targ_Lang_Passage: item.Targ_Lang_Passage?.S || "",
//     Targ_Passage_Word_Timings: item.Targ_Passage_Word_Timings?.S || undefined,
//     Targ_Passage_Audio_URL: item.Targ_Passage_Audio_URL?.S || undefined,
//     Targ_Lang_Question_1: item.Targ_Lang_Question_1?.S || "",
//     Targ_Lang_Answer_1: item.Targ_Lang_Answer_1?.S || "",
//     Targ_Lang_Options_1: item.Targ_Lang_Options_1?.S || "[]", // JSON string
//     Targ_Lang_Question_2: item.Targ_Lang_Question_2?.S || "",
//     Targ_Lang_Answer_2: item.Targ_Lang_Answer_2?.S || "",
//     Targ_Lang_Options_2: item.Targ_Lang_Options_2?.S || "[]", // JSON string
//     Targ_Lang_Question_3: item.Targ_Lang_Question_3?.S || "",
//     Targ_Lang_Answer_3: item.Targ_Lang_Answer_3?.S || "",
//     Targ_Lang_Options_3: item.Targ_Lang_Options_3?.S || "[]", // JSON string
//     Targ_Lang_Question_4: item.Targ_Lang_Question_4?.S || "",
//     Targ_Lang_Answer_4: item.Targ_Lang_Answer_4?.S || "",
//     Targ_Lang_Options_4: item.Targ_Lang_Options_4?.S || "[]", // JSON string
//     ImageURL: item.ImageURL?.S || undefined,
//     Prompt: item.Prompt?.S || undefined,
//     Section: item.Section?.S || "",
//   }));
// };

// export const addPassage = async (data: PassageData): Promise<void> => {
//   await axios.post(`${API_BASE_URL}/add-passage`, data, {
//     headers: { "Content-Type": "application/json" },
//   });
// };

// export const updatePassage = async (
//   identifier: string,
//   level: string,
//   data: Partial<PassageData>
// ): Promise<void> => {
//   await axios.put(
//     `${API_BASE_URL}/update-passage/${identifier}/${level}`,
//     data,
//     {
//       headers: { "Content-Type": "application/json" },
//     }
//   );
// };

// export const deletePassage = async (
//   identifier: string,
//   level: string
// ): Promise<void> => {
//   await axios.delete(`${API_BASE_URL}/delete-passage/${identifier}/${level}`);
// };

// export const uploadImage = async (
//   fileName: string,
//   fileType: string,
//   blob: Blob
// ): Promise<string> => {
//   const response = await axios.post(`${API_BASE_URL}/upload-reading-image`, {
//     fileName,
//     fileType,
//   });
//   const presignedUrl = response.data.url;

//   await axios.put(presignedUrl, blob, {
//     headers: { "Content-Type": fileType },
//   });

//   return presignedUrl.split("?")[0];
// };
